import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map} from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import * as ActionFare from './action';

@Injectable()
export class FareEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  @Effect()
  loadAction$ = this.actions$
    .pipe(
      ofType<ActionFare.PostFareRequest>(ActionFare.POST_Fare),
      map(action => {return action.payload}),
      
    );
  private handleError(error) {
    return of(new ActionFare.Error(error));
  }
}
